function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m53.318 21.364a21.318 21.318 0 1 0-37.306 14.054v21.92a6.6618 6.6618 0 0 0 10.824 5.2015l4.3328-3.4641a1.3324 1.3324 0 0 1 1.6628 0l4.3328 3.4641a6.6618 6.6618 0 0 0 10.824-5.2015v-21.92a21.203 21.203 0 0 0 5.3294-14.054zm-21.318-15.988a15.988 15.988 0 1 1-15.988 15.988 15.988 15.988 0 0 1 15.988-15.988zm9.9048 53.156a1.3084 1.3084 0 0 1-1.4096-0.15988l-4.3328-3.4641a6.6352 6.6352 0 0 0-8.3246 0l-4.3302 3.4641a1.3324 1.3324 0 0 1-2.1664-1.0339v-17.539a21.145 21.145 0 0 0 21.318 0v17.539a1.2977 1.2977 0 0 1-0.75412 1.1938z",
    style: {
      strokeWidth: 2.6647
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.0984449d.svg";
export { ForwardRef as ReactComponent };